export const COMPONENT_NAME = 'EditorialGrid';
